var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as _ from 'lodash';
import * as React from 'react';
import { withRouter } from 'react-router-dom';
import ApiRequests from '../../../classes/http/ApiRequests';
import HttpRequests from '../../../classes/http/HttpRequests';
import Grid from '../../../components/UI/Grid/Grid';
var AromaticNotesList = /** @class */ (function (_super) {
    __extends(AromaticNotesList, _super);
    function AromaticNotesList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.api = new ApiRequests();
        _this.http = new HttpRequests();
        _this.productId = '';
        _this.gridHeaders = [
            { name: 'Стойност', key: 'value', filter: false, sort: false },
            { name: 'Тип на ароматна нотка', key: 'note_type', formatter: 'aromaticNoteTypes', filter: false, sort: false },
        ];
        // public editAromaticNote = (rowItem: any): void => {
        //     this.props.edit(_.get(rowItem, 'id', '-1'));
        // };
        _this.deleteAromaticNote = function (rowItem) {
            var selectedId = _.get(rowItem, 'id', '0');
            var ask = confirm("\u041D\u0430\u0438\u0441\u0442\u0438\u043D\u0430 \u043B\u0438 \u0438\u0441\u043A\u0430\u0442\u0435 \u0434\u0430 \u0438\u0437\u0442\u0440\u0438\u0435\u0442\u0435 \u0442\u0430\u0437\u0438 \u0430\u0440\u043E\u043C\u0430\u0442\u043D\u0430 \u043D\u043E\u0442\u043A\u0430?");
            if (ask) {
                _this.api
                    .deleteAromaticNote(_this.productId, selectedId)
                    .then(function (response) {
                    // Delete the item from the state of the parent component
                    _this.props.deleteItem(selectedId);
                })
                    .catch(function (error) {
                    _this.http.handleError(error, _this.props.messages, 'Ароматната нотка не беше изтрита. Моля, опитайте отново.', _this.props.history);
                });
            }
        };
        return _this;
    }
    AromaticNotesList.prototype.componentDidMount = function () {
        this.productId = _.get(this.props, 'match.params.id', '-1');
    };
    AromaticNotesList.prototype.render = function () {
        var gridData = this.props.gridData;
        return (React.createElement(Grid, { data: gridData, columns: this.gridHeaders, emptyMessage: "", paginator: true, total: 50, rows: 10, 
            // editAction={this.editAromaticNote}
            deleteAction: this.deleteAromaticNote }));
    };
    return AromaticNotesList;
}(React.Component));
// @ts-ignore
export default withRouter(AromaticNotesList);



//////////////////
// WEBPACK FOOTER
// ./src/components/AromaticNotes/AromaticNotesList/AromaticNotesList.tsx
// module id = 320
// module chunks = 0